export default "__VITE_ASSET__BpsbGAd3__"